<div class="bg-ponder-dark min-h-screen w-full overflow-x-hidden flex flex-col"  style="background: linear-gradient(#343346, #1A1922);">
    <div class="flex flex-col items-center justify-center pt-12 pb-12">
        <div class="font-title text-lg sm:text-xl text-white font-bold">
            Choose the plan that meets your needs
        </div>
    </div>
    <div class="flex flex-col sm:flex-row gap-12 sm:gap-4 pb-12 justify-center items-center sm:items-start text-slate-400 text-sm">
        <div class="flex flex-col gap-4 w-96 p-4 rounded-xl bg-ponder-light border border-ponder">
            <div class="text-xl font-bold font-title text-white">
                Free
            </div>
            <div>
                For those just starting their collection journey or want to try us out at no risk.
            </div>
            <div class="flex flex-row items-center justify-center">
                @if (!isAuthed) {
                    <a href="/login" class="w-72 text-center bg-emerald-700 bg-opacity-50 rounded-md shadow p-2 text-faded-90">
                        Please Login
                    </a>
                } @else {
                    @if (!isUserPlus) {
                        <div class="w-72 text-center bg-emerald-700 bg-opacity-50 rounded-md shadow p-2 text-faded-90">
                            Current Plan
                        </div>
                    } @else {
                        <a href="/account/billing" class="w-72 text-center bg-emerald-700 hover:bg-emerald-600 rounded-md shadow p-2 text-faded-90 hover:text-white">
                            Select
                        </a>
                    }
                }
            </div>
            <div class="">
                For <span class="text-xl font-mono text-white ml-2 mr-2">$0.00</span> per month.
            </div>
            <div class="flex flex-row">
                <div class="h-[1px] w-full bg-faded-10"></div>
            </div>
            <div>
                Includes:
            </div>
            <div class="flex flex-col text-slate-100 pl-2">
                <p class="flex flex-row gap-1 items-center"><svg-icon [svgIcon]="chevronIcon" [small]="true" class="stroke-slate-400 fill-none"></svg-icon>Limited ads</p>
                <p class="flex flex-row pt-1 gap-1 items-center"><svg-icon [svgIcon]="chevronIcon" [small]="true" class="stroke-slate-400 fill-none"></svg-icon>Up to 10,000 distinct cards<svg-icon (mouseenter)="toggleDistinctCardTip(!isMobile)" (mouseleave)="toggleDistinctCardTip(false)" (click)="toggleDistinctCardTip(isMobile && !showDistinctCardTip)" [svgIcon]="questionIcon" [small]="true" class="stroke-slate-400 fill-none cursor-pointer"></svg-icon></p>
                <div class="w-0 h-0">
                    <p class="p-2 bg-ponder-xlight rounded-md shadow text-justify z-50 fixed w-80 text-slate-300 mt-1" [ngClass]="{'hidden' : !showDistinctCardTip, 'block' : showDistinctCardTip}">
                        A distinct card refers to a specific printing. If your collection contains 20x <i>Whiptail Wurm</i> from Portal and 20x <i>Whiptail Wurm</i> from Starter 1999, then that counts as 2 distinct collected cards.
                    </p>
                </div>
                <p class="flex flex-row pt-1 gap-1 items-center"><svg-icon [svgIcon]="chevronIcon" [small]="true" class="stroke-slate-400 fill-none"></svg-icon>Up to 50 decks</p>
                <p class="flex flex-row pt-1 gap-1 items-center"><svg-icon [svgIcon]="chevronIcon" [small]="true" class="stroke-slate-400 fill-none"></svg-icon>Card art profile image<svg-icon (mouseenter)="toggleAvatarTip(!isMobile)" (mouseleave)="toggleAvatarTip(false)" (click)="toggleAvatarTip(isMobile && !showAvatarTip)" [svgIcon]="questionIcon" [small]="true" class="stroke-slate-400 fill-none cursor-pointer"></svg-icon></p>
                <div class="w-0 h-0">
                    <p class="p-2 bg-ponder-xlight rounded-md shadow text-justify z-50 fixed w-80 text-slate-300 mt-1" [ngClass]="{'hidden' : !showAvatarTip, 'block' : showAvatarTip}">
                        Profile images can be set by right-clicking most cards and clicking <i>'Set as Profile Image.'</i>
                    </p>
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-4 w-96 p-4 rounded-xl bg-ponder-light border border-ponder" style="box-shadow: 0px 0px 6px #bd93f9 ;">
            <div class="text-xl font-bold font-title text-foil">
                Plus+
            </div>
            <div>
                For those with larger collections or who want to help directly support Ponder.
            </div>
            <div class="flex flex-row items-center justify-center">
                @if (!isAuthed) {
                    <a href="/login" class="w-72 text-center bg-emerald-700 bg-opacity-50 rounded-md shadow p-2 text-faded-90">
                        Please Login
                    </a>
                } @else {
                    @if (isUserPlus) {
                        <div class="w-72 text-center bg-emerald-700 bg-opacity-50 rounded-md shadow p-2 text-faded-90">
                            Current Plan
                        </div>
                    } @else {
                        <a href="/account/upgrade/checkout" class="w-72 text-center bg-emerald-700 hover:bg-emerald-600 rounded-md shadow p-2 text-faded-90 hover:text-white">
                            Select
                        </a>
                    }
                }
            </div>
            <div>
                For <span class="text-xl font-mono text-white ml-2 mr-2">$5.00</span> per month.
            </div>
            <div class="flex flex-row">
                <div class="h-[1px] w-full bg-faded-10"></div>
            </div>
            <div>
                Includes:
            </div>
            <div class="flex flex-col gap-1 text-slate-100 pl-2">
                <p class="flex flex-row gap-1 items-center"><svg-icon [svgIcon]="chevronIcon" [small]="true" class="stroke-slate-400 fill-none"></svg-icon>No ads</p>
                <p class="flex flex-row pt-1 gap-1 items-center"><svg-icon [svgIcon]="chevronIcon" [small]="true" class="stroke-slate-400 fill-none"></svg-icon>Up to 25,000 distinct cards<svg-icon (mouseenter)="toggleDistinctPlusCardTip(!isMobile)" (mouseleave)="toggleDistinctPlusCardTip(false)" (click)="toggleDistinctPlusCardTip(isMobile && !showDistinctPlusCardTip)" [svgIcon]="questionIcon" [small]="true" class="stroke-slate-400 fill-none cursor-pointer"></svg-icon></p>
                <div class="w-0 h-0">
                    <p class="p-2 bg-ponder-xlight rounded-md shadow text-justify z-50 fixed w-80 text-slate-300 mt-1" [ngClass]="{'hidden' : !showDistinctPlusCardTip, 'block' : showDistinctCardTip}">
                        Support for larger collections is planned and will be included automatically with this plan.
                    </p>
                </div>
                <p class="flex flex-row gap-1 items-center"><svg-icon [svgIcon]="chevronIcon" [small]="true" class="stroke-slate-400 fill-none"></svg-icon>Up to 100 decks</p>
                <p class="flex flex-row gap-1 items-center"><svg-icon [svgIcon]="chevronIcon" [small]="true" class="stroke-slate-400 fill-none"></svg-icon>Custom profile image</p>
                <p class="flex flex-row gap-1 items-center"><svg-icon [svgIcon]="chevronIcon" [small]="true" class="stroke-slate-400 fill-none"></svg-icon>Priority queue placement for tasks</p>
            </div>
            <div>
                and automatic access to future planned features.
            </div>
        </div>
    </div>
</div>